import { Visibility } from "@mui/icons-material";
import { observer } from "mobx-react-lite";
import { useState } from "react";
import { useSavedViewStore } from "../..";
import { DeleteControl } from "../EditControls";
import styles from "../InfoWithIconAndNavigation.module.css";
import SavedViewInfo from "./SavedViewInfo";

function SavedViewWithPreviewAndDelete({ id, name, isShared, modifiedDate, createdBy, className, onClick }: ISavedViewWithPreviewAndDeleteProps) {
    const savedViewStore = useSavedViewStore();
    const [isHovered, setIsHovered] = useState(false);

    const click = () => {
        onClick?.();
        savedViewStore.startSavedViewPreview(id);
    };

    const remove = () => {
        savedViewStore.deleteSavedView(id);
    }

    return (
        <div className={[styles.container, className].join(" ")} onClick={click} onMouseEnter={() => setIsHovered(true)} onMouseLeave={() => setIsHovered(false)}>
            <Visibility className={styles.icon} />
            <SavedViewInfo
                name={name}
                isShared={isShared}
                modifiedDate={modifiedDate}
                createdBy={createdBy}
                controls={[
                    isHovered ? (
                        <DeleteControl
                            key={`delete-saved-view-${id}`}
                            entityName="Saved View"
                            isLoading={savedViewStore.isSavedViewsLoading.deleting!}
                            onDelete={remove}
                            onPopupClose={() => setIsHovered(false)}
                            smallSize
                        />
                    ) : null
                ]}
            />

        </div>
    );
}

interface ISavedViewWithPreviewAndDeleteProps {
    id: number;
    name: string;
    isShared: boolean;
    modifiedDate: Date;
    createdBy: string;
    className?: string;
    onClick?: () => void;
}

export default observer(SavedViewWithPreviewAndDelete);
